"use strict";
var ApiPolicy = (function () {
    function ApiPolicy() {
    }
    return ApiPolicy;
}());
exports.ApiPolicy = ApiPolicy;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-policy.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-policy.model.js